import { AbstractControl, ValidationErrors } from '@angular/forms';

const PHONE_STRIP_RE = /[()\-.xX ]/g;
const TEN_DIGITS_RE = /^\d{10}$/;

export function phoneValidator(
  control: AbstractControl<string | null>
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const stripped = control.value.toString().replace(PHONE_STRIP_RE, '');

  if (!TEN_DIGITS_RE.test(stripped)) {
    return { phone: true };
  }

  return null;
}
